import {Injectable} from '@angular/core';
import {AlertService} from '@services/alert.service';

@Injectable({
    providedIn: 'root'
})
export class FormService {

    constructor(private alertService: AlertService) {
    }

    // Display error message from mat-form-field
    getErrorMessage(field) {
        if (field.hasError('required')) {
            return 'You must enter a value';
        } else if (field.hasError('email')) {
            return 'Not a valid email';
        } else if (field.hasError('maxlength')) {
            return 'This value should be less or egal to ' + field.errors.max.max;
        }  else if (field.hasError('minlength')) {
            return 'This value should be more or egal to ' + field.errors.minlength.requiredLength;
        }
        return '';
    }

    parseFormError(err) {
        const errors = [];

        if (err.error.error.errors) {
            Object.keys(err.error.error.errors.global).forEach(function (message) {
                errors.push(err.error.error.errors.global[message]);
            }, this);

            Object.keys(err.error.error.errors.fields).forEach(function (fields) {
                errors.push(fields + ' : ' + err.error.error.errors.fields[fields]);
            }, this);

            this.alertService.error(err.error.error.messagr);
        } else {
            this.alertService.error(err.status + ' ' + err.statusText);
        }

        return errors;
    }
}
